module.exports = __webpack_public_path__ + "img/code-wrapper-bg@2x.92c60da8.png";